import { render } from "./SearchYT.vue?vue&type=template&id=0f3b9717"
import script from "./SearchYT.vue?vue&type=script&lang=js"
export * from "./SearchYT.vue?vue&type=script&lang=js"

import "./SearchYT.vue?vue&type=style&index=0&id=0f3b9717&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__